import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import notificationService from '@/services/notificationService'

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
}

export const fetchNotifications = createAsyncThunk(
  'notification/fetchNotifications',
  async (params, { rejectWithValue }) => {
    try {
      const response = await notificationService.getNotifications(params)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '載入通知失敗')
    }
  }
)

export const fetchUnreadCount = createAsyncThunk(
  'notification/fetchUnreadCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationService.getUnreadCount()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '載入未讀數量失敗')
    }
  }
)

export const markAsRead = createAsyncThunk(
  'notification/markAsRead',
  async (id, { rejectWithValue }) => {
    try {
      await notificationService.markAsRead(id)
      return { id }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '標記失敗')
    }
  }
)

export const markAllAsRead = createAsyncThunk(
  'notification/markAllAsRead',
  async (_, { rejectWithValue }) => {
    try {
      await notificationService.markAllAsRead()
      return {}
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '標記失敗')
    }
  }
)

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch notifications
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false
        const data = action.payload.data
        state.notifications = data.notifications || data || []
        if (data.unread_count !== undefined) {
          state.unreadCount = data.unread_count
        }
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Unread count
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload.data?.unread_count || 0
      })
      // Mark as read
      .addCase(markAsRead.fulfilled, (state, action) => {
        const id = action.payload.id
        state.notifications = state.notifications.map(n =>
          n.id == id ? { ...n, is_read: 1 } : n
        )
        state.unreadCount = Math.max(0, state.unreadCount - 1)
      })
      // Mark all as read
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.notifications = state.notifications.map(n => ({ ...n, is_read: 1 }))
        state.unreadCount = 0
      })
  },
})

export const { clearError } = notificationSlice.actions
export default notificationSlice.reducer
